import { StyledLoginForm } from './style';
import { Input } from '../../Input';
import { Button } from '../../Button';
import { useIntl } from 'react-intl';
import { Checkbox } from 'ui/Checkbox';
import { FormInstance } from 'antd';
import RoutesPath from 'enums/routes';
import { Link, useNavigate } from 'react-router-dom';
import { useCallback, useEffect } from 'react';

export interface RegisterProps {
  appendData: any;
  form: FormInstance<any>;
  isLoading: boolean;
}

const STORAGE_KEY = 'register-form-draft';

export const RegisterForm = ({
  appendData,
  form,
  isLoading,
}: RegisterProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  useEffect(() => {
    const draft = localStorage.getItem(STORAGE_KEY);
    if (draft) {
      try {
        form.setFieldsValue(JSON.parse(draft));
      } catch {}
    }
  }, [form]);

  const handleSubmit = (values: any) => {
    localStorage.removeItem(STORAGE_KEY);

    appendData(values);
  };

  const handleValuesChange = useCallback(() => {
    const allValues = form.getFieldsValue();

    const { password, password_confirmation, ...safeValues } = allValues;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(safeValues));
  }, [form]);

  return (
    <StyledLoginForm
      onFinish={handleSubmit}
      form={form}
      onValuesChange={handleValuesChange}
    >
      <div className={'inputs'}>
        <div className={'registration-title-wrapper'}>
          <div className={'title'}>
            {intl.formatMessage({ id: 'register.title' })}
          </div>
          <p className={'description'}>
            {intl.formatMessage({ id: 'register.description' })}
          </p>
        </div>

        <div className={'registration-input-wrapper'}>
          <div className={'fulname'}>
            <div>
              <span className="label">
                {intl.formatMessage({ id: 'register.name' })}
              </span>

              <Input size={'large'} required name={'name'} />
            </div>
            <div>
              <span className="label">
                {intl.formatMessage({ id: 'register.surname' })}
              </span>
              <Input size={'large'} required name={'surname'} />
            </div>
          </div>

          <div className={'email'}>
            <span className="label">
              {intl.formatMessage({ id: 'register.e_mail' })}
            </span>
            <Input
              size={'large'}
              required
              name={'email'}
              validations={['required', 'email']}
            />
          </div>

          <div className={'email_again'}>
            <span className="label">
              {intl.formatMessage({ id: 'register.e_mail_again' })}
            </span>
            <Input
              size={'large'}
              required
              name={'reemail'}
              dependencies={['email']}
              validations={['required', 'email', 'reemail']}
            />
          </div>

          <div className={'pw-wrap'}>
            <div className={'pw-first'}>
              <span className="label">
                {intl.formatMessage({ id: 'register.password' })}
              </span>
              <Input
                password
                size={'large'}
                required
                name={'password'}
                validations={['required']}
              />
            </div>
            <div className={'pw-scnd'}>
              <span className="label">
                {intl.formatMessage({ id: 'register.password_again' })}
              </span>
              <Input
                password
                size={'large'}
                required
                name={'password_confirmation'}
                dependencies={['password']}
                validations={['required', 'password_confirmation']}
              />
            </div>
          </div>
          <div className={'accept_terms'}>
            <Checkbox name={'accept_terms'} />
            <Link
              to={RoutesPath.TERMS_OF_USE}
              className="link"
              rel="noopener noreferrer"
            >
              {intl.formatMessage({ id: 'register.accept_terms' })}
            </Link>
          </div>
        </div>

        <div className={'registration-button-wrapper'}>
          <div className={'registration-buttons'}>
            <Button
              className={'cstm-btn'}
              label={intl.formatMessage({ id: 'register.register' })}
              size={'large'}
              htmlType={'submit'}
              loading={isLoading}
            />
            <Button
              label={intl.formatMessage({ id: 'register.use_google' })}
              className={'cstm-btn google'}
              icon={<img src={'/google.png'} />}
            />
            <Button
              type={'text'}
              className={'cancel-back-to-landing-page'}
              label={intl.formatMessage({
                id: 'general.cancel',
              })}
              onClick={() => navigate('/')}
            />
          </div>
          <div className={'no-acc-reg'}>
            {intl.formatMessage({ id: 'register.have_acc' })}
            <a href={'/login'} className="login_link">
              {intl.formatMessage({ id: 'register.login' })}
            </a>
          </div>
        </div>
      </div>
    </StyledLoginForm>
  );
};
